import { render, staticRenderFns } from "./PaymentAmount.vue?vue&type=template&id=7438fed5&"
import script from "./PaymentAmount.vue?vue&type=script&lang=js&"
export * from "./PaymentAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports